import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import TemplateDragDropEditor from './TemplateDragDropEditor';
import CarteV2Service from '../../../../services/CarteV2Service';
import './TemplateEditor.css';

const TemplateEditorPage = () => {
    const history = useHistory();
    const location = useLocation();
    const { id } = useParams(); // Get template ID from URL
    const [templateData, setTemplateData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadTemplate();
    }, [id]); // Reload when ID changes

    const loadTemplate = async () => {
        try {
            // Priority: URL parameter ID > location state
            const templateId = id || location.state?.template?.id;

            if (templateId) {
                // Fetch full template details from API using ID from URL
                console.log('Fetching template with ID from URL:', templateId);
                const fullTemplate = await CarteV2Service.getTemplate(templateId);
                console.log('Loaded template:', fullTemplate);
                setTemplateData(fullTemplate);
            } else {
                // New template - no ID in URL
                console.log('Creating new template');
                setTemplateData({
                    name: 'Nouveau Template',
                    description: 'Template créé avec l\'éditeur graphique',
                    category: 'Modern'
                });
            }
        } catch (error) {
            console.error('Error loading template:', error);
            setTemplateData({
                name: 'Nouveau Template',
                description: 'Template créé avec l\'éditeur graphique',
                category: 'Modern'
            });
        } finally {
            setLoading(false);
        }
    };

    const handleSave = (savedTemplate) => {
        console.log('Template saved:', savedTemplate);
        history.push('/cartes/gestion-complete');
    };

    const handleCancel = () => {
        history.push('/cartes/gestion-complete');
    };

    if (loading) {
        return (
            <div className="template-editor-page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                <ProgressSpinner />
            </div>
        );
    }

    if (!templateData) {
        return (
            <div className="template-editor-page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                <p>Erreur lors du chargement du template</p>
                <Button label="Retour" icon="pi pi-arrow-left" onClick={handleCancel} />
            </div>
        );
    }

    return (
        <div className="template-editor-page">
            <div className="template-editor-content">
                <Card className="editor-card">
                    <TemplateDragDropEditor
                        template={templateData}
                        onSave={handleSave}
                        onClose={handleCancel}
                        fullPage={true}
                    />
                </Card>
            </div>
        </div>
    );
};

export default TemplateEditorPage;